/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface ApClassInstanceDTO
 */
export interface ApClassInstanceDTOOptional {
  /**
   *
   * @type {number}
   * @memberof ApClassInstanceDTO
   */
  instanceId?: number;
  /**
   *
   * @type {string}
   * @memberof ApClassInstanceDTO
   */
  typeName?: string;
  /**
   *
   * @type {string}
   * @memberof ApClassInstanceDTO
   */
  startDate?: string;
  /**
   *
   * @type {string}
   * @memberof ApClassInstanceDTO
   */
  startTime?: string;
  /**
   *
   * @type {string}
   * @memberof ApClassInstanceDTO
   */
  locationString?: string;
  /**
   *
   * @type {number}
   * @memberof ApClassInstanceDTO
   */
  enrollees?: number;
}

export interface ApClassInstanceDTO extends ApClassInstanceDTOOptional {
  /**
   *
   * @type {number}
   * @memberof ApClassInstanceDTO
   */
  instanceId: number;
  /**
   *
   * @type {string}
   * @memberof ApClassInstanceDTO
   */
  typeName?: string;
  /**
   *
   * @type {string}
   * @memberof ApClassInstanceDTO
   */
  startDate: string;
  /**
   *
   * @type {string}
   * @memberof ApClassInstanceDTO
   */
  startTime: string;
  /**
   *
   * @type {string}
   * @memberof ApClassInstanceDTO
   */
  locationString?: string;
  /**
   *
   * @type {number}
   * @memberof ApClassInstanceDTO
   */
  enrollees: number;
}

export interface ApClassInstanceDTOTrackedI {
  /**
   *
   * @type {number}
   * @memberof ApClassInstanceDTO
   */
  instanceId?: number;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassInstanceDTO
   */
  typeName?: string;
  typeNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassInstanceDTO
   */
  startDate?: string;
  startDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassInstanceDTO
   */
  startTime?: string;
  startTimeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassInstanceDTO
   */
  locationString?: string;
  locationStringIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ApClassInstanceDTO
   */
  enrollees?: number;
  enrolleesIsSet: boolean;
}

transformDatesMap.set(
  "ApClassInstanceDTO",
  function (model: ApClassInstanceDTO) {},
);

export type ApClassInstanceDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  typeName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  startDate: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  startTime: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  locationString: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  enrollees: PropertyMeta<MetaTypeBase<number>>;
}>;

export var ApClassInstanceDTOMeta: ApClassInstanceDTOMetaI =
  {} as ApClassInstanceDTOMetaI;
ApClassInstanceDTOMeta = typeMeta("ApClassInstanceDTO", {
  instanceId: propertyMeta(
    "instanceId",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  typeName: propertyMeta("typeName", false, false, false, MetaTypesBase.string),
  startDate: propertyMeta(
    "startDate",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  startTime: propertyMeta(
    "startTime",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  locationString: propertyMeta(
    "locationString",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  enrollees: propertyMeta(
    "enrollees",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = ApClassInstanceDTOMeta;

registerMeta(() => {});

export class ApClassInstanceDTOTracked implements ApClassInstanceDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  instanceId__I?: number = undefined;
  instanceIdIsSet: boolean = false;
  set instanceId(v: undefined | number) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  typeName__I?: string = undefined;
  typeNameIsSet: boolean = false;
  set typeName(v: undefined | string) {
    if (v !== undefined) {
      this.typeName__I = v;
      this.typeNameIsSet = true;
    } else {
      this.typeName__I = v || undefined;
      this.typeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeName() {
    return this.typeName__I;
  }
  startDate__I?: string = undefined;
  startDateIsSet: boolean = false;
  set startDate(v: undefined | string) {
    if (v !== undefined) {
      this.startDate__I = v;
      this.startDateIsSet = true;
    } else {
      this.startDate__I = v || undefined;
      this.startDateIsSet = true;
    }
    this.changeTracker = true;
  }
  get startDate() {
    return this.startDate__I;
  }
  startTime__I?: string = undefined;
  startTimeIsSet: boolean = false;
  set startTime(v: undefined | string) {
    if (v !== undefined) {
      this.startTime__I = v;
      this.startTimeIsSet = true;
    } else {
      this.startTime__I = v || undefined;
      this.startTimeIsSet = true;
    }
    this.changeTracker = true;
  }
  get startTime() {
    return this.startTime__I;
  }
  locationString__I?: string = undefined;
  locationStringIsSet: boolean = false;
  set locationString(v: undefined | string) {
    if (v !== undefined) {
      this.locationString__I = v;
      this.locationStringIsSet = true;
    } else {
      this.locationString__I = v || undefined;
      this.locationStringIsSet = false;
    }
    this.changeTracker = true;
  }
  get locationString() {
    return this.locationString__I;
  }
  enrollees__I?: number = undefined;
  enrolleesIsSet: boolean = false;
  set enrollees(v: undefined | number) {
    if (v !== undefined) {
      this.enrollees__I = v;
      this.enrolleesIsSet = true;
    } else {
      this.enrollees__I = v || undefined;
      this.enrolleesIsSet = true;
    }
    this.changeTracker = true;
  }
  get enrollees() {
    return this.enrollees__I;
  }
  constructor(config?: ApClassInstanceDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: ApClassInstanceDTOOptional,
    options?: AssignOptions,
  ): ApClassInstanceDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = config.instanceId;
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (config.typeName && this.typeNameApplyFilter(optionsRequired.filter)) {
      this.typeName = config.typeName;
      if (optionsRequired.unassign) this.typeNameIsSet = false;
      else this.typeNameIsSet = true;
    }
    if (config.startDate && this.startDateApplyFilter(optionsRequired.filter)) {
      this.startDate = config.startDate;
      if (optionsRequired.unassign) this.startDateIsSet = false;
      else this.startDateIsSet = true;
    }
    if (config.startTime && this.startTimeApplyFilter(optionsRequired.filter)) {
      this.startTime = config.startTime;
      if (optionsRequired.unassign) this.startTimeIsSet = false;
      else this.startTimeIsSet = true;
    }
    if (
      config.locationString &&
      this.locationStringApplyFilter(optionsRequired.filter)
    ) {
      this.locationString = config.locationString;
      if (optionsRequired.unassign) this.locationStringIsSet = false;
      else this.locationStringIsSet = true;
    }
    if (config.enrollees && this.enrolleesApplyFilter(optionsRequired.filter)) {
      this.enrollees = config.enrollees;
      if (optionsRequired.unassign) this.enrolleesIsSet = false;
      else this.enrolleesIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ApClassInstanceDTOTrackedI {
    const cloned = {} as ApClassInstanceDTOTrackedI;
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId;
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.typeNameIsSetDeep() &&
      this.typeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeNameIsSet = true;
      cloned.typeName = this.typeName;
    } else {
      //cloned.typeNameIsSet = false
    }
    if (
      this.startDateIsSetDeep() &&
      this.startDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startDateIsSet = true;
      cloned.startDate = this.startDate;
    } else {
      //cloned.startDateIsSet = false
    }
    if (
      this.startTimeIsSetDeep() &&
      this.startTimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startTimeIsSet = true;
      cloned.startTime = this.startTime;
    } else {
      //cloned.startTimeIsSet = false
    }
    if (
      this.locationStringIsSetDeep() &&
      this.locationStringApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.locationStringIsSet = true;
      cloned.locationString = this.locationString;
    } else {
      //cloned.locationStringIsSet = false
    }
    if (
      this.enrolleesIsSetDeep() &&
      this.enrolleesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.enrolleesIsSet = true;
      cloned.enrollees = this.enrollees;
    } else {
      //cloned.enrolleesIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ApClassInstanceDTOTrackedI {
    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;

    if (!this.typeNameApplyFilter(filter)) this.typeNameIsSet = false;

    if (!this.startDateApplyFilter(filter)) this.startDateIsSet = false;

    if (!this.startTimeApplyFilter(filter)) this.startTimeIsSet = false;

    if (!this.locationStringApplyFilter(filter))
      this.locationStringIsSet = false;

    if (!this.enrolleesApplyFilter(filter)) this.enrolleesIsSet = false;

    return this;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassInstanceDTOMeta.instanceId,
      ApClassInstanceDTOMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;

    return false;
  }
  typeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassInstanceDTOMeta.typeName,
      ApClassInstanceDTOMeta,
      this.typeName,
      this,
    );
  }
  typeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeNameIsSet && this.typeNameApplyFilter(filter)) return true;

    return false;
  }
  startDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassInstanceDTOMeta.startDate,
      ApClassInstanceDTOMeta,
      this.startDate,
      this,
    );
  }
  startDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startDateIsSet && this.startDateApplyFilter(filter)) return true;

    return false;
  }
  startTimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassInstanceDTOMeta.startTime,
      ApClassInstanceDTOMeta,
      this.startTime,
      this,
    );
  }
  startTimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startTimeIsSet && this.startTimeApplyFilter(filter)) return true;

    return false;
  }
  locationStringApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassInstanceDTOMeta.locationString,
      ApClassInstanceDTOMeta,
      this.locationString,
      this,
    );
  }
  locationStringIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.locationStringIsSet && this.locationStringApplyFilter(filter))
      return true;

    return false;
  }
  enrolleesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassInstanceDTOMeta.enrollees,
      ApClassInstanceDTOMeta,
      this.enrollees,
      this,
    );
  }
  enrolleesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.enrolleesIsSet && this.enrolleesApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.typeNameIsSetDeep(filter)) return true;
    if (this.startDateIsSetDeep(filter)) return true;
    if (this.startTimeIsSetDeep(filter)) return true;
    if (this.locationStringIsSetDeep(filter)) return true;
    if (this.enrolleesIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
